import React, { useState, useMemo, useEffect } from "react";
import { Check, Calendar, Home, Building2, X, MapPin } from 'lucide-react';
import "../../Styles/PC/BookTestsModal.css";
import { bookLabTestsAPI } from "../../services/pcConfigService";
import { toast } from "react-toastify";
import { getAllDiagnosticCentersAPI } from "../../services/pcConfigService";

const BookTestsModal = ({ phaseData, patientId, patientInfo, isReviewTest, onClose }) => {
    console.log('phasedata', phaseData, patientId, patientInfo, isReviewTest);

    let pendingTests;
    if (isReviewTest) {
        pendingTests = phaseData?.reviewDiagnostics?.filter(
            (test) => test.testStatus === "PENDING"
        ) || [];
    } else {
        pendingTests = phaseData?.diagnostics?.filter(
            (test) => test.testStatus === "PENDING"
        ) || [];
    }

    const [selectedTests, setSelectedTests] = useState([]);
    const [homeDate, setHomeDate] = useState("");
    const [radiologyDate, setRadiologyDate] = useState("");
    const [homeTime, setHomeTime] = useState("");
    const [radiologyTime, setRadiologyTime] = useState("");
    const [homeAddress, setHomeAddress] = useState("");
    const [diagnostics, setDiagnostics] = useState([]);
    const [selectedDiagnosticCenter, setSelectedDiagnosticCenter] = useState(null);

    useEffect(() => {
        fetchAllDiagnostics();
        setHomeAddress(patientInfo?.address?.street + ", " + patientInfo?.address?.city + ", " + patientInfo?.address?.district + ", " + patientInfo?.address?.state + " - " + patientInfo?.address?.pinCode);
    }, []);

    const fetchAllDiagnostics = async () => {
        try {
            const response = await getAllDiagnosticCentersAPI();
            console.log('all diagnostics', response)
            if (response?.data?.length > 0) {
                setDiagnostics(response?.data)
            }
        } catch (error) {
            console.error("Error fetching diagnostics:", error);
        }
    };

    const toggleTest = (test) => {
        setSelectedTests((prev) =>
            prev.some((t) => t._id === test._id)
                ? prev.filter((t) => t._id !== test._id)
                : [...prev, test]
        );
    };

    const isPathologyOrGeneticSelected = selectedTests.some(
        (test) =>
            test.testType === "PATHOLOGY" ||
            test.testType === "GENETIC"
    );

    const isRadiologySelected = selectedTests.some(
        (test) => test.testType === "RADIOLOGY"
    );

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    };

    const generateTimeSlots = (selectedDate) => {
        if (!selectedDate) return [];

        const slots = [];
        const today = new Date();
        const selected = new Date(selectedDate);

        const isToday =
            selected.toDateString() === today.toDateString();

        let startHour;
        let endHour;

        if (isToday) {
            const currentHour = today.getHours();
            const currentMinutes = today.getMinutes();
            startHour = currentMinutes > 0 ? currentHour + 1 : currentHour;
            endHour = 23;
        } else {
            startHour = 10;
            endHour = 22;
        }

        for (let hour = startHour; hour < endHour; hour++) {
            const start = new Date(selectedDate);
            start.setHours(hour, 0, 0, 0);

            const end = new Date(selectedDate);
            end.setHours(hour + 1, 0, 0, 0);

            const format = (date) =>
                date.toLocaleTimeString("en-US", {
                    hour: "numeric",
                    hour12: true,
                });

            slots.push(`${format(start)} - ${format(end)}`);
        }

        return slots;
    };

    const homeTimeSlots = useMemo(
        () => generateTimeSlots(homeDate),
        [homeDate]
    );

    const radiologyTimeSlots = useMemo(
        () => generateTimeSlots(radiologyDate),
        [radiologyDate]
    );

    const handleConfirm = async () => {
        if (selectedTests.length === 0) return;

        const formatDate = (dateString) => {
            const date = new Date(dateString);
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        };

        const splitSlot = (slot) => {
            if (!slot) return { slotStart: "", slotEnds: "" };
            const [start, end] = slot.split(" - ");
            return {
                slotStart: start.toLowerCase(),
                slotEnds: end.toLowerCase(),
            };
        };
        console.log(selectedDiagnosticCenter, '---------------DDDDDDDDDD----')
        const tests = selectedTests.map((test) => {
            // Home Collection (PATHOLOGY / GENETIC)
            if (test.testType === "PATHOLOGY" || test.testType === "GENETIC") {
                const { slotStart, slotEnds } = splitSlot(homeTime);

                return {
                    testID: test.testID,
                    date: formatDate(homeDate),
                    slotStart,
                    slotEnds,
                };
            }

            // Radiology
            if (test.testType === "RADIOLOGY") {
                const { slotStart, slotEnds } = splitSlot(radiologyTime);

                return {
                    testID: test.testID,
                    diagnosticCenterID: selectedDiagnosticCenter,
                    slotStart,
                    slotEnds,
                };
            }

            return null;
        }).filter(Boolean);

        const payload = {
            patientID: patientId,
            mainPatientID: patientId,
            phaseNumber: phaseData?.phaseNumber,
            isReview: isReviewTest,
            tests,
        };

        console.log("======= FINAL REQUEST PAYLOAD =======");
        console.log(JSON.stringify(payload));
        console.log("=====================================");
        console.log(payload);
        // return;
        // Uncomment when ready
        const response = await bookLabTestsAPI(payload);
        console.log("Response:", response);
        if (response?.status == 'success') {
            toast.success(response?.message);
            onClose();
        } else {
            toast.error(response?.message);
        }
        // onClose();
    };

    // Helper functions for icons/text
    const getTestIcon = (testType) => {
        if (testType === "RADIOLOGY") return <Building2 size={14} className="btm-badge-icon" />;
        return <Home size={14} className="btm-badge-icon" />;
    };

    const getTestLabel = (testType) => {
        if (testType === "RADIOLOGY") return "Diagnostic Center";
        return "Home Collection";
    };

    return (
        <div className="btm-overlay">
            <div className="btm-modal">
                <div className="btm-header">
                    <h3>Select Tests</h3>
                    <button className="btm-close" onClick={onClose}>
                        <X size={24} />
                    </button>
                </div>

                <p className="btm-instruction">
                    Select tests to book. Home sample collection is available for Genetic, Gut Microbiome, and Blood & Urine tests. DEXA scan requires a visit to the diagnostic center.
                </p>

                <div className="btm-header-sub">
                    <h4>Select Tests</h4>
                </div>

                {/* Pending Test Selection */}
                <div className="btm-test-grid">
                    {pendingTests.map((test) => {
                        const isSelected = selectedTests.some(
                            (t) => t._id === test._id
                        );

                        return (
                            <div
                                key={test._id}
                                className={`btm-test-card ${isSelected ? "selected" : ""}`}
                                onClick={() => toggleTest(test)}
                            >
                                <div className="btm-test-card-top">
                                    <div className={`btm-checkbox ${isSelected ? "checked" : ""}`}>
                                        {isSelected && <Check size={14} strokeWidth={3} />}
                                    </div>
                                    <span className="btm-test-name">{test.testName}</span>
                                </div>
                                <div className="btm-test-badge">
                                    {getTestIcon(test.testType)}
                                    <span>{getTestLabel(test.testType)}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="test-booking-cards">
                    {/* Home Collection */}
                    {isPathologyOrGeneticSelected && (
                        <div className="btm-section-card">
                            <div className="btm-section-header">
                                <Home className="btm-section-icon" size={20} />
                                <h4>Home Sample Collection</h4>
                            </div>

                            <div className="btm-section-subtext">
                                For: {selectedTests.filter(t => t.testType !== 'RADIOLOGY').map(t => t.testName).join(', ')}
                            </div>

                            <div className="btm-row">
                                <div className="btm-input-group">
                                    <label>Collection Date</label>
                                    <div className="btm-input-wrapper">
                                        {/* <Calendar className="btm-input-icon" size={16} /> */}
                                        <input
                                            type="date"
                                            min={getTodayDate()}
                                            value={homeDate}
                                            onChange={(e) => {
                                                setHomeDate(e.target.value);
                                                setHomeTime("");
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="btm-input-group">
                                    <label>Time Slot</label>
                                    <div className="btm-input-wrapper">
                                        <select
                                            disabled={!homeDate}
                                            value={homeTime}
                                            onChange={(e) =>
                                                setHomeTime(e.target.value)
                                            }
                                        >
                                            <option value="">Select time</option>
                                            {homeTimeSlots.map(
                                                (slot, index) => (
                                                    <option
                                                        key={index}
                                                        value={slot}
                                                    >
                                                        {slot}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="btm-input-group">
                                <label>Home Address</label>
                                <div className="btm-input-wrapper">
                                    <MapPin className="btm-input-icon" size={18} />
                                    <input
                                        type="text"
                                        placeholder="Enter complete address for sample collection"
                                        value={homeAddress}
                                        onChange={(e) =>
                                            setHomeAddress(
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Radiology */}
                    {isRadiologySelected && (
                        <div className="btm-section-card">
                            <div className="btm-section-header">
                                <Building2 className="btm-section-icon" size={20} />
                                <h4>DEXA Scan Appointment</h4>
                            </div>

                            <div className="btm-input-group">
                                <label>Diagnostic Center</label>
                                <div className="btm-input-wrapper">
                                    <select value={selectedDiagnosticCenter}
                                        onChange={(e) => setSelectedDiagnosticCenter(e.target.value)}>
                                        <option>Select diagnostic center</option>
                                        {diagnostics?.map((diagnostic) => (
                                            <option key={diagnostic._id} value={diagnostic._id}>
                                                {diagnostic.centerName} - {diagnostic.address} - {diagnostic.city}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="btm-row">
                                <div className="btm-input-group">
                                    <label>Appointment Date</label>
                                    <div className="btm-input-wrapper">
                                        <input
                                            type="date"
                                            min={getTodayDate()}
                                            value={radiologyDate}
                                            onChange={(e) => {
                                                setRadiologyDate(
                                                    e.target.value
                                                );
                                                setRadiologyTime("");
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="btm-input-group">
                                    <label>Time Slot</label>
                                    <div className="btm-input-wrapper">
                                        <select
                                            disabled={!radiologyDate}
                                            value={radiologyTime}
                                            onChange={(e) =>
                                                setRadiologyTime(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="">Select time</option>
                                            {radiologyTimeSlots.map(
                                                (slot, index) => (
                                                    <option
                                                        key={index}
                                                        value={slot}
                                                    >
                                                        {slot}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="btm-footer">
                    <button
                        className="btm-secondary"
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="btm-primary"
                        onClick={handleConfirm}
                        disabled={selectedTests.length === 0}
                    >
                        Confirm Booking
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookTestsModal;
